// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Poppins Font */

/* Plans Container */
.plans-container {
  padding: 1.5rem 1rem;
  max-width: 100%;
  width: 100%;
  margin: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
  box-sizing: border-box;
}
/* Enhanced Header */
.plans-header {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
  padding-bottom: 1rem;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.header-text {
  flex: 1 1;
  min-width: 300px;
}

.header-text h1 {
  color: white;
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  font-family: "Poppins", sans-serif;
  line-height: 1.2;
}
.header-text p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 300;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  line-height: 1.5;
  max-width: 500px;
  font-family: "Poppins", sans-serif;
}

/* Enhanced Header Elements */
 
.header-features {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
  justify-content: center;
}

.feature-highlight {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.feature-highlight:hover {
  color: white;
  transform: translateY(-2px);
}

.feature-highlight svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.header-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 60px;
  overflow: hidden;
}

.header-wave svg {
  width: 100%;
  height: 100%;
}


.header-stats {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.stat-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.25);
  min-width: 100px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.stat-card:hover {
  transform: translateY(-5px) scale(1.02);
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.stat-card.featured {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2) 0%, rgba(255, 152, 0, 0.2) 100%);
  border-color: rgba(255, 193, 7, 0.4);
  box-shadow: 0 0 25px rgba(255, 193, 7, 0.4);
}

.stat-icon {
  width: 24px;
  height: 24px;
  margin: 0 auto 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.stat-card .stat-number {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.25rem;
}

.stat-card .stat-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}
/* Enhanced Controls Section */
.plans-controls {
  margin-bottom: 1.5rem;
  padding: 1.2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}


.controls-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.controls-left, .controls-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Search Component */
.search-container {
  position: relative;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 0.85rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(15px);
  width: 250px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  font-family: "Poppins", sans-serif;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.search-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.18);
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15), 0 0 0 4px rgba(255, 255, 255, 0.1);
}

/* Search Suggestions */
.search-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 0.75rem;
  padding: 1.25rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
  z-index: 100;
  animation: slideDown 0.3s ease-out;
}

.search-suggestions p {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.suggestion-tags {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.suggestion-tags button {
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.suggestion-tags button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
}

.clear-search {
  position: absolute;
  right: 0.5rem;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.clear-search:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

/* Filter Toggle */
.filter-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.filter-toggle svg {
  width: 16px;
  height: 16px;
}

.filter-toggle:hover,
.filter-toggle.active {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}

/* Sort Container */
.sort-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sort-container label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  font-weight: 500;
}

.sort-select {
  padding: 0.5rem 0.75rem;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sort-select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.15);
}


/* Enhanced Button Styles */
.compare-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
  font-size: 0.8rem;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
}



.btn-text {
  position: relative;
  z-index: 1;
}

.btn-count {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  margin-left: 0.25rem;
}

.compare-btn svg {
  width: 16px;
  height: 16px;
}

.compare-btn:hover:not(:disabled) {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 30px rgba(40, 167, 69, 0.4), 0 0 0 2px rgba(40, 167, 69, 0.2);
  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
}


.compare-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Filter Panel */
.filter-panel {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.filter-section h3 {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.filter-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.filter-option:hover {
  background: rgba(255, 255, 255, 0.05);
}

.filter-option input[type="radio"] {
  accent-color: #007bff;
}

.filter-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
}

.filter-count {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

/* Results Summary */
.results-summary {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 4px solid #007bff;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.results-summary p {
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 0.9rem;
}

.results-summary strong {
  color: white;
  font-weight: 600;
}

/* Plans Grid */
.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.2rem;
  margin-bottom: 2.5rem;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  align-items: stretch;
}


/* Enhanced Plan Card with Glass Morphism */
.plan-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 1.2rem;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15), 0 1px 0 rgba(255, 255, 255, 0.4) inset;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}


.plan-card:hover {
  transform: translateY(-8px) scale(1.01);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  border-color: #007bff;
}

.plan-card.popular {
  border-color: #28a745;
  transform: scale(1.05);
  box-shadow: 0 12px 40px rgba(40, 167, 69, 0.2);
}

.plan-card.popular:hover {
  transform: translateY(-10px) scale(1.07);
}

.plan-card.selecting {
  opacity: 0.8;
  pointer-events: none;
}

/* Plan Badges */
.plan-badge {
  position: absolute;
  top: -2px;
  right: 20px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0 0 12px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.plan-badge.trial {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

.plan-badge.free {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
}

.plan-badge.popular {
  background: linear-gradient(135deg, #fd7e14 0%, #e63946 100%);
}

.plan-badge.recommended {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  top: -2px;
  right: 15px;
}

/* Plan Header */
.plan-header {
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

/* Tooltip Styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: fixed;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  max-width: 200px;
  text-align: center;
  pointer-events: none;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: tooltipFadeIn 0.2s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 5px solid transparent;
}

.tooltip-arrow-top {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: rgba(0, 0, 0, 0.9);
}

.tooltip-arrow-bottom {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: rgba(0, 0, 0, 0.9);
}

/* Enhanced Plan Header */
.plan-title-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.plan-header h3 {
  color: #333;
  font-size: 1.3rem;
  margin: 0;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.info-icon {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-icon svg {
  width: 16px;
  height: 16px;
}

.info-icon:hover {
  color: #007bff;
  background: rgba(0, 123, 255, 0.1);
  transform: scale(1.1);
}

.price-display {
  cursor: help;
}

.plan-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0.5rem 0 1rem 0;
  line-height: 1.4;
  font-family: "Poppins", sans-serif;
  min-height: 3em;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.plan-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 1rem;
  gap: 0.2rem;
}

.plan-price .amount {
  font-size: 2.2rem;
  font-weight: 800;
  color: #007bff;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.plan-price .period {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
}

/* Plan Stats */
.plan-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  gap: 0.6rem;
  margin-bottom: 1rem;
  padding: 0.8rem;
  background: rgba(0, 123, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 123, 255, 0.1);
  flex-shrink: 0;
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 1.4rem;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 0.3rem;
}

.stat-label {
  font-size: 0.85rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.stat-icon {
  margin-top: 0.5rem;
  opacity: 0.7;
}

.stat-icon svg {
  width: 14px;
  height: 14px;
  stroke-width: 1.5;
}

.stat-item.highlight {
  background: linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(32, 201, 151, 0.1) 100%);
  border: 1px solid rgba(40, 167, 69, 0.2);
  border-radius: 8px;
  padding: 0.5rem;
}

.stat-item.highlight .stat-number {
  color: #28a745;
}

.stat-item.highlight .stat-icon {
  color: #28a745;
  opacity: 1;
}



/* Plan Actions */
.plan-actions {
  margin-top: auto;
  text-align: center;
  flex-shrink: 0;
  padding-top: 0.8rem;
}

.plan-select-btn {
  width: 100%;
  padding: 1rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 12px;
  border: 2px solid transparent;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
}

.btn-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.3);
}

.btn-outline {
  background: transparent;
  color: #007bff;
  border-color: #007bff;
}

.btn-outline:hover:not(:disabled) {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.3);
}

.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.trial-note {
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.5rem;
  text-align: center;
  font-style: italic;
}

/* Loading State */
.plans-loading {
  text-align: center;
  padding: 4rem 0;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.plans-loading p {
  color: #666;
  font-size: 1.1rem;
}

/* Error State */
.plans-error {
  text-align: center;
  padding: 4rem 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.plans-error h2 {
  color: #dc3545;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.plans-error p {
  color: #666;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

/* No Plans State */
.no-plans {
  grid-column: 1 / -1;
  text-align: center;
  padding: 4rem 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.no-plans h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.no-plans p {
  color: #666;
  font-size: 1.1rem;
}

/* Enhanced No Plans State */
.no-plans-content {
  text-align: center;
  padding: 4rem 2rem;
}

.no-plans-icon {
  margin: 0 auto 1.5rem;
  width: 64px;
  height: 64px;
  color: rgba(255, 255, 255, 0.4);
}

.no-plans-icon svg {
  width: 100%;
  height: 100%;
}

.no-plans h3 {
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.no-plans p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Poppins", sans-serif;
}

.clear-filters-btn {
  margin-top: 1rem;
}

/* Enhanced Plans Actions */
.plans-actions {
  margin-top: 3rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.actions-left .help-text {
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-size: 0.95rem;
}

.link-btn {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  transition: color 0.2s ease;
}

.link-btn:hover:not(:disabled) {
  color: #0056b3;
}

.link-btn:disabled {
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
  text-decoration: none;
}

.skip-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  font-size: 1rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.skip-btn svg {
  width: 16px;
  height: 16px;
}

.skip-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Comparison Modal */
.comparison-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: overlayFadeIn 0.3s ease-out;
}

@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.comparison-modal-content {
  background: white;
  border-radius: 20px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.comparison-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.comparison-modal-header h2 {
  margin: 0;
  color: #333;
  font-weight: 600;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #333;
}

.comparison-table-container {
  padding: 2rem;
  overflow: auto;
  max-height: 70vh;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.comparison-table th,
.comparison-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.comparison-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
  position: sticky;
  top: 0;
  z-index: 1;
}

.comparison-table td {
  color: #555;
}

.comparison-table tr:hover {
  background: #f8f9fa;
}

/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  background: rgba(255, 255, 255, 0.95);
  padding: 2rem 3rem;
  border-radius: 16px;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

.loading-content p {
  margin: 0;
  color: #333;
  font-weight: 500;
}

/* Button Styles */
.btn {
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
  border-color: #004085;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border: 1px solid #6c757d;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #545b62;
  border-color: #4e555b;
}

/* Enhanced Responsive Design */

/* Large Desktop */
@media (min-width: 1400px) {
  .plans-container {
    padding: 3rem 2rem;
  }
  
  .header-text h1 {
    font-size: 3.5rem;
  }
  
  .header-text p {
    font-size: 1.4rem;
  }
  
  .plans-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
    max-width: 1400px;
  }
}

/* Desktop */
@media (max-width: 1200px) {
  .plans-container {
    padding: 2rem 1rem;
  }
  
  .header-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
  }
  
  .header-stats {
    justify-content: center;
    gap: 1.5rem;
  }
  
  .controls-container {
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .controls-left,
  .controls-right {
    width: 100%;
    justify-content: center;
  }
  
  .search-input {
    width: 100%;
    max-width: 400px;
  }
  
  .plans-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
  }
}

/* Tablet */
@media (max-width: 992px) {
  .header-features {
    justify-content: center;
    gap: 1rem;
  }
  
  .feature-highlight {
    font-size: 0.85rem;
  }
  
  .plans-grid {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
  }
  
  .controls-right {
    flex-wrap: wrap;
    gap: 1rem;
  }
}

/* Mobile Large */
@media (max-width: 768px) {
  .plans-container {
    padding: 1.5rem 1rem;
  }
  
  .header-text h1 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    line-height: 1.1;
  }
  
  .header-text p {
    font-size: 0.95rem;
    margin-bottom: 0.8rem;
  }
  
  .stat-card {
    min-width: 110px;
    padding: 1rem;
    flex: 1 1;
  }
  
  .stat-card .stat-number {
    font-size: 1.5rem;
  }
  
  .header-features {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }
  
  .plans-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .plan-card {
    padding: 1.5rem 1.2rem;
    border-radius: 16px;
  }
  
  .plan-price .amount {
    font-size: 1.8rem;
  }
  
  .search-input {
    width: 100%;
    max-width: 100%;
    padding: 1rem 1rem 1rem 2.5rem;
    font-size: 16px; /* Prevent zoom on iOS */
  }
  
  .header-stats {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }
  
  .stat-card {
    min-width: 100%;
    padding: 0.875rem;
  }
  
  .controls-right {
    width: 100%;
    justify-content: space-between;
  }
  
  .compare-btn .btn-text {
    display: none;
  }
  
  .actions-content {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
  
  .comparison-modal-overlay {
    padding: 1rem;
  }
  
  .comparison-table-container {
    padding: 1rem;
  }
  
  .comparison-table th,
  .comparison-table td {
    padding: 0.75rem 0.5rem;
    font-size: 0.9rem;
  }
}

/* Mobile Small */
@media (max-width: 480px) {
  .plans-container {
    padding: 1rem 0.75rem;
  }
  
  .header-text h1 {
    font-size: 1.7rem;
    line-height: 1.2;
  }
  
  .header-text p {
    font-size: 0.9rem;
    line-height: 1.5;
  }
  
  .header-features {
    gap: 0.5rem;
  }
  
  .feature-highlight {
    font-size: 0.8rem;
  }
  
  .plans-controls {
    padding: 1rem;
  }
  
  .controls-container {
    gap: 1rem;
  }
  
  .controls-right {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .compare-btn {
    width: 100%;
    max-width: 200px;
    padding: 1rem;
    justify-content: center;
  }
  
  .plan-card {
    padding: 1.5rem;
    margin: 0 0.25rem;
  }
  
  .plan-header h3 {
    font-size: 1.4rem;
  }
  
  .plan-price .amount {
    font-size: 2rem;
  }
  
  .plan-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    padding: 0.875rem;
  }
  
  .stat-item {
    text-align: center;
  }
  
  .stat-number {
    font-size: 1.25rem;
  }
  
  .stat-label {
    font-size: 0.7rem;
  }
  
  .plan-select-btn {
    padding: 1rem;
    font-size: 1rem;
    border-radius: 15px;
    /* Touch optimization */
    min-height: 48px;
    touch-action: manipulation;
  }
  
  /* Payment Modal Mobile */
  .payment-modal-content {
    width: 95%;
    margin: 1rem 0.5rem;
    max-height: 85vh;
  }
  
  .payment-options-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .payment-option {
    padding: 1.25rem;
  }
  
  /* Improved scrolling */
  .plans-grid {
    scroll-snap-type: x mandatory;
  }
  
  .plan-card {
    scroll-snap-align: start;
  }
}

/* Accessibility and Performance Improvements */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
  
  .plan-card:hover {
    transform: none;
  }
  
  .backgroundMove,
  .badgePulse,
  .waveMove,
  .featuredGlow {
    animation: none !important;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .plan-card {
    border: 3px solid #000;
  }
  
  .search-input,
  .sort-select {
    border: 2px solid #000;
  }
  
  .tooltip-content {
    background: #000;
    border: 2px solid #fff;
  }
}

/* Maintain Original Colors - Remove Dark Mode Override */

/* Touch Device Optimizations */
@media (hover: none) and (pointer: coarse) {
  .plan-card:hover {
    transform: none;
  }
  
  .btn:hover {
    transform: none;
  }
  
  /* Larger touch targets */
  .search-input {
    min-height: 44px;
  }
  
  .compare-btn {
    min-height: 44px;
    min-width: 44px;
  }
  
  /* Remove hover states for touch devices */
  .stat-card:hover,
  .feature-highlight:hover {
    transform: none;
    color: inherit;
  }
}


/* Focus Management for Accessibility */
.plan-card:focus {
  outline: 3px solid #007bff;
  outline-offset: 2px;
}

.btn:focus,
.search-input:focus,
.sort-select:focus,
.filter-toggle:focus,
.view-btn:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Screen Reader Only Content */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 480px) {
  .plans-header h1 {
    font-size: 1.5rem;
  }
  
  .plans-header p {
    font-size: 1rem;
  }
  
  .plan-card {
    padding: 1rem;
  }
  
  .plan-header h3 {
    font-size: 1.25rem;
  }
  
  .plan-price .amount {
    font-size: 1.75rem;
  }
}

/* Enhanced Payment Modal with Benefits and Gateways */
.payment-list {
  padding: 1.5rem;
  max-height: 70vh;
  overflow-y: auto;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
}

.payment-plan-card {
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 1.5rem;
  position: relative;
  backdrop-filter: blur(15px);
  transition: all 0.3s ease;
}

.payment-plan-card:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.discount-tag {
  position: absolute;
  top: -8px;
  right: 20px;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 2;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.plan-header-info {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 1rem;
}

.plan-title-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.plan-title-price h4 {
  color: white;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  font-family: "Poppins", sans-serif;
}

.plan-price-display {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
}

.price-amount {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(135deg, #007bff, #0056b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.price-period {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  font-weight: 500;
}

.equivalent-price {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  margin: 0;
  font-style: italic;
  text-align: right;
}

.plan-benefits {
  margin-bottom: 1.5rem;
}

.plan-benefits h5 {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  font-family: "Poppins", sans-serif;
}

.plan-benefits ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.plan-benefits li {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.payment-gateways h5 {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  font-family: "Poppins", sans-serif;
}

.gateway-options {
  display: grid;
  gap: 0.75rem;
}

.gateway-btn {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Poppins", sans-serif;
  width: 100%;
  text-align: left;
}

.gateway-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateX(4px);
}

.gateway-btn.processing {
  background: rgba(0, 123, 255, 0.2);
  border-color: rgba(0, 123, 255, 0.4);
  cursor: not-allowed;
}

.gateway-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.gateway-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.gateway-logo-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 4px;
}

.gateway-emoji-icon {
  font-size: 1.5rem;
}

.gateway-info {
  flex: 1 1;
}

.gateway-name {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
}

.gateway-desc {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
  display: block;
}

.gateway-arrow {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.2rem;
  font-weight: bold;
}

.gateway-processing {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.gateway-processing .spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.no-gateways-message {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

.no-gateways-message p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin: 0;
  font-style: italic;
}

/* Payment Options Modal */
.payment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(8px);
  animation: overlayFadeIn 0.3s ease-out;
}

.payment-modal-content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  position: relative;
}

.payment-modal-header {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  text-align: center;
}

.payment-modal-header h2 {
  color: white;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.payment-modal-header p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin-bottom: 0;
}

.plan-group-info {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.plan-group-title h3 {
  color: white;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.plan-group-title p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
}

.plan-group-features .feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.9rem;
}

.feature-text {
  color: rgba(255, 255, 255, 0.9);
}

.payment-options {
  padding: 2rem;
}

.payment-options h4 {
  color: white;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.payment-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.payment-option {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
  position: relative;
  backdrop-filter: blur(10px);
}

.payment-option:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.payment-option.processing {
  pointer-events: none;
  opacity: 0.7;
}

.discount-badge {
  position: absolute;
  top: -8px;
  right: 16px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.payment-option-header {
  margin-bottom: 1rem;
}

.payment-option-header h5 {
  color: white;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.payment-price {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
}

.payment-price .price-amount {
  color: white;
  font-size: 2rem;
  font-weight: 700;
}

.payment-price .price-period {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
}

.monthly-equivalent {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  margin: 0.5rem 0 1rem;
  font-style: italic;
}

.payment-features {
  margin-bottom: 1.5rem;
}

.payment-features p {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.payment-select-btn {
  width: 100%;
  padding: 1rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
}

/* Plan Group Card Enhancements */
.plan-group-card {
  position: relative;
}

.plan-badge.multiple-options {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  top: 15px;
  left: 20px;
  right: auto;
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
}

.price-range {
  color: #007bff;
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.5rem;
}

.plan-billing-options {
  margin: 0.5rem 0;
  padding: 0.6rem;
  background: rgba(0, 123, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 123, 255, 0.1);
  flex-shrink: 0;
}

.billing-preview {
  text-align: center;
}

.billing-option {
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
}

.billing-info {
  color: #666;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  display: block;
}

/* Responsive Design for Enhanced Payment Modal */
@media (max-width: 768px) {
  .payment-modal-content {
    width: 95%;
    margin: 1rem;
    max-width: 450px;
  }
  
  .payment-list {
    padding: 1rem;
    gap: 1rem;
  }
  
  .payment-plan-card {
    padding: 1.2rem;
  }
  
  .plan-title-price {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .equivalent-price {
    text-align: left;
  }
  
  .plan-benefits {
    margin-bottom: 1.2rem;
  }
  
  .plan-benefits li {
    font-size: 0.85rem;
  }
  
  .gateway-btn {
    padding: 0.8rem;
    gap: 0.75rem;
  }
  
  .gateway-icon {
    width: 30px;
    height: 30px;
  }
  
  .gateway-logo-img {
    width: 24px;
    height: 24px;
  }
  
  .gateway-emoji-icon {
    font-size: 1.2rem;
  }
  
  .gateway-name {
    font-size: 0.9rem;
  }
  
  .gateway-desc {
    font-size: 0.75rem;
  }
  
  .payment-modal-header {
    padding: 1rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AdvertiserPortal/Styles/plans.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB,oBAAoB;AACpB;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,SAAS;EACT,6DAA6D;EAC7D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;AACA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,2BAA2B;EAC3B,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;EACrC,uCAAuC;EACvC,8EAA8E;AAChF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;AACvC;;;AAGA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,gFAAgF;EAChF,6DAA6D;AAC/D;;;AAGA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA,2CAA2C;AAC3C;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kFAAkF;EAClF,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;;AAGA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,SAAS;EACT,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4FAA4F;EAC5F,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;;;AAIA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,+BAA+B;;AAE/B,kBAAkB;AAClB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;IAC3D,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,SAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,+CAA+C;AAC/C;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,yDAAyD;;AAEzD,+BAA+B;AAC/B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;;IAEE,eAAe;IACf,cAAc;EAChB;AACF;;;AAGA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* Import Poppins Font */\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n/* Plans Container */\n.plans-container {\n  padding: 1.5rem 1rem;\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n  font-family: \"Poppins\", sans-serif;\n  box-sizing: border-box;\n}\n/* Enhanced Header */\n.plans-header {\n  margin-bottom: 2rem;\n  position: relative;\n  z-index: 1;\n  padding-bottom: 1rem;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.header-text {\n  flex: 1;\n  min-width: 300px;\n}\n\n.header-text h1 {\n  color: white;\n  font-size: 2.2rem;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.3);\n  font-family: \"Poppins\", sans-serif;\n  line-height: 1.2;\n}\n.header-text p {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  font-weight: 300;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.2);\n  line-height: 1.5;\n  max-width: 500px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n/* Enhanced Header Elements */\n \n.header-features {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-top: 0.75rem;\n  justify-content: center;\n}\n\n.feature-highlight {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.feature-highlight:hover {\n  color: white;\n  transform: translateY(-2px);\n}\n\n.feature-highlight svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));\n}\n\n.header-wave {\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  overflow: hidden;\n}\n\n.header-wave svg {\n  width: 100%;\n  height: 100%;\n}\n\n\n.header-stats {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(15px);\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  min-width: 100px;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.stat-card.featured {\n  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2) 0%, rgba(255, 152, 0, 0.2) 100%);\n  border-color: rgba(255, 193, 7, 0.4);\n  box-shadow: 0 0 25px rgba(255, 193, 7, 0.4);\n}\n\n.stat-icon {\n  width: 24px;\n  height: 24px;\n  margin: 0 auto 0.75rem;\n  color: rgba(255, 255, 255, 0.8);\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.stat-card .stat-number {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 0.25rem;\n}\n\n.stat-card .stat-label {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.8);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n/* Enhanced Controls Section */\n.plans-controls {\n  margin-bottom: 1.5rem;\n  padding: 1.2rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n\n.controls-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n  position: relative;\n  z-index: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.controls-left, .controls-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* Search Component */\n.search-container {\n  position: relative;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input {\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  font-size: 0.85rem;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  backdrop-filter: blur(15px);\n  width: 250px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  position: relative;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.search-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.18);\n  transform: translateY(-2px) scale(1.02);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15), 0 0 0 4px rgba(255, 255, 255, 0.1);\n}\n\n/* Search Suggestions */\n.search-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 0.75rem;\n  padding: 1.25rem;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(15px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);\n  z-index: 100;\n  animation: slideDown 0.3s ease-out;\n}\n\n.search-suggestions p {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.suggestion-tags {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.suggestion-tags button {\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 25px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n}\n\n.suggestion-tags button:hover {\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.75rem;\n  width: 16px;\n  height: 16px;\n  color: rgba(255, 255, 255, 0.6);\n  pointer-events: none;\n}\n\n.clear-search {\n  position: absolute;\n  right: 0.5rem;\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.clear-search:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Filter Toggle */\n.filter-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.filter-toggle svg {\n  width: 16px;\n  height: 16px;\n}\n\n.filter-toggle:hover,\n.filter-toggle.active {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateY(-1px);\n}\n\n/* Sort Container */\n.sort-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sort-container label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.sort-select {\n  padding: 0.5rem 0.75rem;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sort-select:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.4);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n\n/* Enhanced Button Styles */\n.compare-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.6rem 1rem;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);\n  font-size: 0.8rem;\n  font-weight: 600;\n  position: relative;\n  overflow: hidden;\n  font-family: \"Poppins\", sans-serif;\n}\n\n\n\n.btn-text {\n  position: relative;\n  z-index: 1;\n}\n\n.btn-count {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  margin-left: 0.25rem;\n}\n\n.compare-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.compare-btn:hover:not(:disabled) {\n  transform: translateY(-4px) scale(1.02);\n  box-shadow: 0 12px 30px rgba(40, 167, 69, 0.4), 0 0 0 2px rgba(40, 167, 69, 0.2);\n  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);\n}\n\n\n.compare-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Filter Panel */\n.filter-panel {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.filter-section h3 {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.filter-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n}\n\n.filter-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.filter-option:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.filter-option input[type=\"radio\"] {\n  accent-color: #007bff;\n}\n\n.filter-label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n}\n\n.filter-count {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n}\n\n/* Results Summary */\n.results-summary {\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border-left: 4px solid #007bff;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.results-summary p {\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.results-summary strong {\n  color: white;\n  font-weight: 600;\n}\n\n/* Plans Grid */\n.plans-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.2rem;\n  margin-bottom: 2.5rem;\n  width: 100%;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  align-items: stretch;\n}\n\n\n/* Enhanced Plan Card with Glass Morphism */\n.plan-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  padding: 1.2rem;\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15), 0 1px 0 rgba(255, 255, 255, 0.4) inset;\n  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n\n.plan-card:hover {\n  transform: translateY(-8px) scale(1.01);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);\n  border-color: #007bff;\n}\n\n.plan-card.popular {\n  border-color: #28a745;\n  transform: scale(1.05);\n  box-shadow: 0 12px 40px rgba(40, 167, 69, 0.2);\n}\n\n.plan-card.popular:hover {\n  transform: translateY(-10px) scale(1.07);\n}\n\n.plan-card.selecting {\n  opacity: 0.8;\n  pointer-events: none;\n}\n\n/* Plan Badges */\n.plan-badge {\n  position: absolute;\n  top: -2px;\n  right: 20px;\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0 0 12px 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  z-index: 2;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.plan-badge.trial {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n}\n\n.plan-badge.free {\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n}\n\n.plan-badge.popular {\n  background: linear-gradient(135deg, #fd7e14 0%, #e63946 100%);\n}\n\n.plan-badge.recommended {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  top: -2px;\n  right: 15px;\n}\n\n/* Plan Header */\n.plan-header {\n  text-align: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n  flex-shrink: 0;\n}\n\n/* Tooltip Styles */\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-content {\n  position: fixed;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  max-width: 200px;\n  text-align: center;\n  pointer-events: none;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  animation: tooltipFadeIn 0.2s ease-out;\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 5px solid transparent;\n}\n\n.tooltip-arrow-top {\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.tooltip-arrow-bottom {\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-bottom-color: rgba(0, 0, 0, 0.9);\n}\n\n/* Enhanced Plan Header */\n.plan-title-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.plan-header h3 {\n  color: #333;\n  font-size: 1.3rem;\n  margin: 0;\n  font-weight: 700;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.info-icon {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.info-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.info-icon:hover {\n  color: #007bff;\n  background: rgba(0, 123, 255, 0.1);\n  transform: scale(1.1);\n}\n\n.price-display {\n  cursor: help;\n}\n\n.plan-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0.5rem 0 1rem 0;\n  line-height: 1.4;\n  font-family: \"Poppins\", sans-serif;\n  min-height: 3em;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.plan-price {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  margin-bottom: 1rem;\n  gap: 0.2rem;\n}\n\n.plan-price .amount {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: #007bff;\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.plan-price .period {\n  font-size: 1rem;\n  color: #666;\n  font-weight: 500;\n}\n\n/* Plan Stats */\n.plan-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));\n  gap: 0.6rem;\n  margin-bottom: 1rem;\n  padding: 0.8rem;\n  background: rgba(0, 123, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(0, 123, 255, 0.1);\n  flex-shrink: 0;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-number {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #007bff;\n  margin-bottom: 0.3rem;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.stat-icon {\n  margin-top: 0.5rem;\n  opacity: 0.7;\n}\n\n.stat-icon svg {\n  width: 14px;\n  height: 14px;\n  stroke-width: 1.5;\n}\n\n.stat-item.highlight {\n  background: linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(32, 201, 151, 0.1) 100%);\n  border: 1px solid rgba(40, 167, 69, 0.2);\n  border-radius: 8px;\n  padding: 0.5rem;\n}\n\n.stat-item.highlight .stat-number {\n  color: #28a745;\n}\n\n.stat-item.highlight .stat-icon {\n  color: #28a745;\n  opacity: 1;\n}\n\n\n\n/* Plan Actions */\n.plan-actions {\n  margin-top: auto;\n  text-align: center;\n  flex-shrink: 0;\n  padding-top: 0.8rem;\n}\n\n.plan-select-btn {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  font-family: \"Poppins\", sans-serif;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.3);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.3);\n}\n\n.btn-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.trial-note {\n  font-size: 0.8rem;\n  color: #666;\n  margin-top: 0.5rem;\n  text-align: center;\n  font-style: italic;\n}\n\n/* Loading State */\n.plans-loading {\n  text-align: center;\n  padding: 4rem 0;\n}\n\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.plans-loading p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n/* Error State */\n.plans-error {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.plans-error h2 {\n  color: #dc3545;\n  margin-bottom: 1rem;\n  font-size: 1.8rem;\n}\n\n.plans-error p {\n  color: #666;\n  margin-bottom: 2rem;\n  font-size: 1.1rem;\n}\n\n/* No Plans State */\n.no-plans {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.no-plans h3 {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.no-plans p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n/* Enhanced No Plans State */\n.no-plans-content {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.no-plans-icon {\n  margin: 0 auto 1.5rem;\n  width: 64px;\n  height: 64px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.no-plans-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.no-plans h3 {\n  color: white;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.no-plans p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.clear-filters-btn {\n  margin-top: 1rem;\n}\n\n/* Enhanced Plans Actions */\n.plans-actions {\n  margin-top: 3rem;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.actions-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.actions-left .help-text {\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.link-btn {\n  background: none;\n  border: none;\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  padding: 0;\n  transition: color 0.2s ease;\n}\n\n.link-btn:hover:not(:disabled) {\n  color: #0056b3;\n}\n\n.link-btn:disabled {\n  color: rgba(255, 255, 255, 0.4);\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.skip-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.skip-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.skip-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Comparison Modal */\n.comparison-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  animation: overlayFadeIn 0.3s ease-out;\n}\n\n@keyframes overlayFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.comparison-modal-content {\n  background: white;\n  border-radius: 20px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.comparison-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #eee;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n}\n\n.comparison-modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-weight: 600;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close-btn:hover {\n  background: rgba(0, 0, 0, 0.1);\n  color: #333;\n}\n\n.comparison-table-container {\n  padding: 2rem;\n  overflow: auto;\n  max-height: 70vh;\n}\n\n.comparison-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0;\n}\n\n.comparison-table th,\n.comparison-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.comparison-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #333;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.comparison-table td {\n  color: #555;\n}\n\n.comparison-table tr:hover {\n  background: #f8f9fa;\n}\n\n/* Loading Overlay */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-content {\n  background: rgba(255, 255, 255, 0.95);\n  padding: 2rem 3rem;\n  border-radius: 16px;\n  text-align: center;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n.loading-content p {\n  margin: 0;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Button Styles */\n.btn {\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n  border: 1px solid #007bff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #0056b3;\n  border-color: #004085;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n  border: 1px solid #6c757d;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #545b62;\n  border-color: #4e555b;\n}\n\n/* Enhanced Responsive Design */\n\n/* Large Desktop */\n@media (min-width: 1400px) {\n  .plans-container {\n    padding: 3rem 2rem;\n  }\n  \n  .header-text h1 {\n    font-size: 3.5rem;\n  }\n  \n  .header-text p {\n    font-size: 1.4rem;\n  }\n  \n  .plans-grid {\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 2rem;\n    max-width: 1400px;\n  }\n}\n\n/* Desktop */\n@media (max-width: 1200px) {\n  .plans-container {\n    padding: 2rem 1rem;\n  }\n  \n  .header-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 2rem;\n  }\n  \n  .header-stats {\n    justify-content: center;\n    gap: 1.5rem;\n  }\n  \n  .controls-container {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .controls-left,\n  .controls-right {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .search-input {\n    width: 100%;\n    max-width: 400px;\n  }\n  \n  .plans-grid {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n  }\n}\n\n/* Tablet */\n@media (max-width: 992px) {\n  .header-features {\n    justify-content: center;\n    gap: 1rem;\n  }\n  \n  .feature-highlight {\n    font-size: 0.85rem;\n  }\n  \n  .plans-grid {\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 2rem;\n  }\n  \n  .controls-right {\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n}\n\n/* Mobile Large */\n@media (max-width: 768px) {\n  .plans-container {\n    padding: 1.5rem 1rem;\n  }\n  \n  .header-text h1 {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n    line-height: 1.1;\n  }\n  \n  .header-text p {\n    font-size: 0.95rem;\n    margin-bottom: 0.8rem;\n  }\n  \n  .stat-card {\n    min-width: 110px;\n    padding: 1rem;\n    flex: 1;\n  }\n  \n  .stat-card .stat-number {\n    font-size: 1.5rem;\n  }\n  \n  .header-features {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n  }\n  \n  .plans-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .plan-card {\n    padding: 1.5rem 1.2rem;\n    border-radius: 16px;\n  }\n  \n  .plan-price .amount {\n    font-size: 1.8rem;\n  }\n  \n  .search-input {\n    width: 100%;\n    max-width: 100%;\n    padding: 1rem 1rem 1rem 2.5rem;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n  \n  .header-stats {\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%;\n  }\n  \n  .stat-card {\n    min-width: 100%;\n    padding: 0.875rem;\n  }\n  \n  .controls-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .compare-btn .btn-text {\n    display: none;\n  }\n  \n  .actions-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 1.5rem;\n  }\n  \n  .comparison-modal-overlay {\n    padding: 1rem;\n  }\n  \n  .comparison-table-container {\n    padding: 1rem;\n  }\n  \n  .comparison-table th,\n  .comparison-table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Mobile Small */\n@media (max-width: 480px) {\n  .plans-container {\n    padding: 1rem 0.75rem;\n  }\n  \n  .header-text h1 {\n    font-size: 1.7rem;\n    line-height: 1.2;\n  }\n  \n  .header-text p {\n    font-size: 0.9rem;\n    line-height: 1.5;\n  }\n  \n  .header-features {\n    gap: 0.5rem;\n  }\n  \n  .feature-highlight {\n    font-size: 0.8rem;\n  }\n  \n  .plans-controls {\n    padding: 1rem;\n  }\n  \n  .controls-container {\n    gap: 1rem;\n  }\n  \n  .controls-right {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .compare-btn {\n    width: 100%;\n    max-width: 200px;\n    padding: 1rem;\n    justify-content: center;\n  }\n  \n  .plan-card {\n    padding: 1.5rem;\n    margin: 0 0.25rem;\n  }\n  \n  .plan-header h3 {\n    font-size: 1.4rem;\n  }\n  \n  .plan-price .amount {\n    font-size: 2rem;\n  }\n  \n  .plan-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    padding: 0.875rem;\n  }\n  \n  .stat-item {\n    text-align: center;\n  }\n  \n  .stat-number {\n    font-size: 1.25rem;\n  }\n  \n  .stat-label {\n    font-size: 0.7rem;\n  }\n  \n  .plan-select-btn {\n    padding: 1rem;\n    font-size: 1rem;\n    border-radius: 15px;\n    /* Touch optimization */\n    min-height: 48px;\n    touch-action: manipulation;\n  }\n  \n  /* Payment Modal Mobile */\n  .payment-modal-content {\n    width: 95%;\n    margin: 1rem 0.5rem;\n    max-height: 85vh;\n  }\n  \n  .payment-options-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .payment-option {\n    padding: 1.25rem;\n  }\n  \n  /* Improved scrolling */\n  .plans-grid {\n    scroll-snap-type: x mandatory;\n  }\n  \n  .plan-card {\n    scroll-snap-align: start;\n  }\n}\n\n/* Accessibility and Performance Improvements */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n  \n  .plan-card:hover {\n    transform: none;\n  }\n  \n  .backgroundMove,\n  .badgePulse,\n  .waveMove,\n  .featuredGlow {\n    animation: none !important;\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .plan-card {\n    border: 3px solid #000;\n  }\n  \n  .search-input,\n  .sort-select {\n    border: 2px solid #000;\n  }\n  \n  .tooltip-content {\n    background: #000;\n    border: 2px solid #fff;\n  }\n}\n\n/* Maintain Original Colors - Remove Dark Mode Override */\n\n/* Touch Device Optimizations */\n@media (hover: none) and (pointer: coarse) {\n  .plan-card:hover {\n    transform: none;\n  }\n  \n  .btn:hover {\n    transform: none;\n  }\n  \n  /* Larger touch targets */\n  .search-input {\n    min-height: 44px;\n  }\n  \n  .compare-btn {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  /* Remove hover states for touch devices */\n  .stat-card:hover,\n  .feature-highlight:hover {\n    transform: none;\n    color: inherit;\n  }\n}\n\n\n/* Focus Management for Accessibility */\n.plan-card:focus {\n  outline: 3px solid #007bff;\n  outline-offset: 2px;\n}\n\n.btn:focus,\n.search-input:focus,\n.sort-select:focus,\n.filter-toggle:focus,\n.view-btn:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n/* Screen Reader Only Content */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 480px) {\n  .plans-header h1 {\n    font-size: 1.5rem;\n  }\n  \n  .plans-header p {\n    font-size: 1rem;\n  }\n  \n  .plan-card {\n    padding: 1rem;\n  }\n  \n  .plan-header h3 {\n    font-size: 1.25rem;\n  }\n  \n  .plan-price .amount {\n    font-size: 1.75rem;\n  }\n}\n\n/* Enhanced Payment Modal with Benefits and Gateways */\n.payment-list {\n  padding: 1.5rem;\n  max-height: 70vh;\n  overflow-y: auto;\n  gap: 1.5rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-plan-card {\n  background: rgba(255, 255, 255, 0.08);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 1.5rem;\n  position: relative;\n  backdrop-filter: blur(15px);\n  transition: all 0.3s ease;\n}\n\n.payment-plan-card:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.discount-tag {\n  position: absolute;\n  top: -8px;\n  right: 20px;\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  z-index: 2;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.plan-header-info {\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 1rem;\n}\n\n.plan-title-price {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.plan-title-price h4 {\n  color: white;\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.plan-price-display {\n  display: flex;\n  align-items: baseline;\n  gap: 0.25rem;\n}\n\n.price-amount {\n  color: white;\n  font-size: 1.8rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.price-period {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.equivalent-price {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.85rem;\n  margin: 0;\n  font-style: italic;\n  text-align: right;\n}\n\n.plan-benefits {\n  margin-bottom: 1.5rem;\n}\n\n.plan-benefits h5 {\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.plan-benefits ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.plan-benefits li {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.payment-gateways h5 {\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.gateway-options {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.gateway-btn {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: \"Poppins\", sans-serif;\n  width: 100%;\n  text-align: left;\n}\n\n.gateway-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateX(4px);\n}\n\n.gateway-btn.processing {\n  background: rgba(0, 123, 255, 0.2);\n  border-color: rgba(0, 123, 255, 0.4);\n  cursor: not-allowed;\n}\n\n.gateway-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.gateway-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.gateway-logo-img {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.gateway-emoji-icon {\n  font-size: 1.5rem;\n}\n\n.gateway-info {\n  flex: 1;\n}\n\n.gateway-name {\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.gateway-desc {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.8rem;\n  display: block;\n}\n\n.gateway-arrow {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.gateway-processing {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.gateway-processing .spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.no-gateways-message {\n  text-align: center;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px dashed rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n}\n\n.no-gateways-message p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n  margin: 0;\n  font-style: italic;\n}\n\n/* Payment Options Modal */\n.payment-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  backdrop-filter: blur(8px);\n  animation: overlayFadeIn 0.3s ease-out;\n}\n\n.payment-modal-content {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n  position: relative;\n}\n\n.payment-modal-header {\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n  text-align: center;\n}\n\n.payment-modal-header h2 {\n  color: white;\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.payment-modal-header p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  margin-bottom: 0;\n}\n\n.plan-group-info {\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.plan-group-title h3 {\n  color: white;\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.plan-group-title p {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 1.5rem;\n}\n\n.plan-group-features .feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.9rem;\n}\n\n.feature-text {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.payment-options {\n  padding: 2rem;\n}\n\n.payment-options h4 {\n  color: white;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.payment-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.payment-option {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  backdrop-filter: blur(10px);\n}\n\n.payment-option:hover {\n  transform: translateY(-4px);\n  border-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.payment-option.processing {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.discount-badge {\n  position: absolute;\n  top: -8px;\n  right: 16px;\n  background: linear-gradient(135deg, #ff6b6b, #ee5a24);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.payment-option-header {\n  margin-bottom: 1rem;\n}\n\n.payment-option-header h5 {\n  color: white;\n  font-size: 1.2rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.payment-price {\n  display: flex;\n  align-items: baseline;\n  gap: 0.25rem;\n}\n\n.payment-price .price-amount {\n  color: white;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.payment-price .price-period {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n}\n\n.monthly-equivalent {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.85rem;\n  margin: 0.5rem 0 1rem;\n  font-style: italic;\n}\n\n.payment-features {\n  margin-bottom: 1.5rem;\n}\n\n.payment-features p {\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.payment-select-btn {\n  width: 100%;\n  padding: 1rem;\n  font-weight: 600;\n  font-size: 1rem;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n}\n\n/* Plan Group Card Enhancements */\n.plan-group-card {\n  position: relative;\n}\n\n.plan-badge.multiple-options {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  top: 15px;\n  left: 20px;\n  right: auto;\n  padding: 0.4rem 0.8rem;\n  border-radius: 12px;\n}\n\n.price-range {\n  color: #007bff;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n\n.plan-billing-options {\n  margin: 0.5rem 0;\n  padding: 0.6rem;\n  background: rgba(0, 123, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(0, 123, 255, 0.1);\n  flex-shrink: 0;\n}\n\n.billing-preview {\n  text-align: center;\n}\n\n.billing-option {\n  color: #666;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.billing-info {\n  color: #666;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-align: center;\n  display: block;\n}\n\n/* Responsive Design for Enhanced Payment Modal */\n@media (max-width: 768px) {\n  .payment-modal-content {\n    width: 95%;\n    margin: 1rem;\n    max-width: 450px;\n  }\n  \n  .payment-list {\n    padding: 1rem;\n    gap: 1rem;\n  }\n  \n  .payment-plan-card {\n    padding: 1.2rem;\n  }\n  \n  .plan-title-price {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .equivalent-price {\n    text-align: left;\n  }\n  \n  .plan-benefits {\n    margin-bottom: 1.2rem;\n  }\n  \n  .plan-benefits li {\n    font-size: 0.85rem;\n  }\n  \n  .gateway-btn {\n    padding: 0.8rem;\n    gap: 0.75rem;\n  }\n  \n  .gateway-icon {\n    width: 30px;\n    height: 30px;\n  }\n  \n  .gateway-logo-img {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .gateway-emoji-icon {\n    font-size: 1.2rem;\n  }\n  \n  .gateway-name {\n    font-size: 0.9rem;\n  }\n  \n  .gateway-desc {\n    font-size: 0.75rem;\n  }\n  \n  .payment-modal-header {\n    padding: 1rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
